(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-page"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var links=document.querySelectorAll('.as-spine__item');
  var sections=document.querySelectorAll('.as-section[id]');
  if(!links.length||!sections.length)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        links.forEach(function(l){l.classList.remove('is-active');});
        var id=e.target.getAttribute('id');
        var active=document.querySelector('.as-spine__item[href="#'+id+'"]');
        if(active)active.classList.add('is-active');
      }
    });
  },{rootMargin:'-30% 0px -60% 0px'});
  sections.forEach(function(s){obs.observe(s);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-us-page"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var links=document.querySelectorAll('.as-spine__item');
  var sections=document.querySelectorAll('.as-section[id]');
  if(!links.length||!sections.length)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        links.forEach(function(l){l.classList.remove('is-active');});
        var id=e.target.getAttribute('id');
        var active=document.querySelector('.as-spine__item[href="#'+id+'"]');
        if(active)active.classList.add('is-active');
      }
    });
  },{rootMargin:'-30% 0px -60% 0px'});
  sections.forEach(function(s){obs.observe(s);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs-page"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var links=document.querySelectorAll('.as-spine__item');
  var sections=document.querySelectorAll('.as-section[id]');
  if(!links.length||!sections.length)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        links.forEach(function(l){l.classList.remove('is-active');});
        var id=e.target.getAttribute('id');
        var active=document.querySelector('.as-spine__item[href="#'+id+'"]');
        if(active)active.classList.add('is-active');
      }
    });
  },{rootMargin:'-30% 0px -60% 0px'});
  sections.forEach(function(s){obs.observe(s);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-notice-page"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var links=document.querySelectorAll('.as-spine__item');
  var sections=document.querySelectorAll('.as-section[id]');
  if(!links.length||!sections.length)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        links.forEach(function(l){l.classList.remove('is-active');});
        var id=e.target.getAttribute('id');
        var active=document.querySelector('.as-spine__item[href="#'+id+'"]');
        if(active)active.classList.add('is-active');
      }
    });
  },{rootMargin:'-30% 0px -60% 0px'});
  sections.forEach(function(s){obs.observe(s);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["payment-policy-page"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var links=document.querySelectorAll('.as-spine__item');
  var sections=document.querySelectorAll('.as-section[id]');
  if(!links.length||!sections.length)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        links.forEach(function(l){l.classList.remove('is-active');});
        var id=e.target.getAttribute('id');
        var active=document.querySelector('.as-spine__item[href="#'+id+'"]');
        if(active)active.classList.add('is-active');
      }
    });
  },{rootMargin:'-30% 0px -60% 0px'});
  sections.forEach(function(s){obs.observe(s);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy-policy-page"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var links=document.querySelectorAll('.as-spine__item');
  var sections=document.querySelectorAll('.as-section[id]');
  if(!links.length||!sections.length)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        links.forEach(function(l){l.classList.remove('is-active');});
        var id=e.target.getAttribute('id');
        var active=document.querySelector('.as-spine__item[href="#'+id+'"]');
        if(active)active.classList.add('is-active');
      }
    });
  },{rootMargin:'-30% 0px -60% 0px'});
  sections.forEach(function(s){obs.observe(s);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["returns-refunds-page"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var links=document.querySelectorAll('.as-spine__item');
  var sections=document.querySelectorAll('.as-section[id]');
  if(!links.length||!sections.length)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        links.forEach(function(l){l.classList.remove('is-active');});
        var id=e.target.getAttribute('id');
        var active=document.querySelector('.as-spine__item[href="#'+id+'"]');
        if(active)active.classList.add('is-active');
      }
    });
  },{rootMargin:'-30% 0px -60% 0px'});
  sections.forEach(function(s){obs.observe(s);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-policy-page"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var links=document.querySelectorAll('.as-spine__item');
  var sections=document.querySelectorAll('.as-section[id]');
  if(!links.length||!sections.length)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        links.forEach(function(l){l.classList.remove('is-active');});
        var id=e.target.getAttribute('id');
        var active=document.querySelector('.as-spine__item[href="#'+id+'"]');
        if(active)active.classList.add('is-active');
      }
    });
  },{rootMargin:'-30% 0px -60% 0px'});
  sections.forEach(function(s){obs.observe(s);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terms-of-service-page"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var links=document.querySelectorAll('.as-spine__item');
  var sections=document.querySelectorAll('.as-section[id]');
  if(!links.length||!sections.length)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        links.forEach(function(l){l.classList.remove('is-active');});
        var id=e.target.getAttribute('id');
        var active=document.querySelector('.as-spine__item[href="#'+id+'"]');
        if(active)active.classList.add('is-active');
      }
    });
  },{rootMargin:'-30% 0px -60% 0px'});
  sections.forEach(function(s){obs.observe(s);});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["us-consumer-law-page"]) return;
  try {
    
document.addEventListener('DOMContentLoaded',function(){
  var links=document.querySelectorAll('.as-spine__item');
  var sections=document.querySelectorAll('.as-section[id]');
  if(!links.length||!sections.length)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        links.forEach(function(l){l.classList.remove('is-active');});
        var id=e.target.getAttribute('id');
        var active=document.querySelector('.as-spine__item[href="#'+id+'"]');
        if(active)active.classList.add('is-active');
      }
    });
  },{rootMargin:'-30% 0px -60% 0px'});
  sections.forEach(function(s){obs.observe(s);});
});

  } catch(e) { console.error(e); }
})();
})();
